import index from './page/index';
import Toolkit from './utils/utils';
import Anim from './utils/doAnim';
import Carousel from './plugins/carousel';
let myself = Toolkit.myself;

Carousel();
index();

Toolkit.commonFunction.suitable();

// 首页动效
let hGroups = new Anim($("hGroup.hTitle:not(.datetime)"), myself.slideUpBigIn);
let proList = new Anim($(".pro-list"), myself.slideUpBigIn);
let caseList = new Anim($(".case-list"), myself.slideUpBigIn);
let newsList = new Anim($(".info-card-list"), myself.slideUpBigIn);
let tabList = new Anim($(".nav-list"), myself.slideUpIn);
let video = new Anim($(".video-container"), myself.slideUpIn);
let aboutP = new Anim($(".about-container > p.white"), myself.slideUpBigIn);


// 图片懒加载
let pics = $("img[data-src]");
const clientH = document.documentElement.clientHeight;

/*=================== 滚动事件 ===================*/
$(window).scroll(() => {
	
    hGroups.doit();
    proList.doit();
    caseList.doit();
    newsList.doit();
    tabList.doit();
    video.doit();
    aboutP.doit();

    // 图片加载
 //    Array.from(pics).map((v, i) => {
 //    	const rect = v.getBoundingClientRect();
	// 	if(rect.top < clientH) {

	// 		const loading = $("<div>加载中...</div>");

	// 		// todo...  加载中制作
	// 		$(v).parent().append(loading);

	// 		if(v.complete) {
	// 			v.src = v.dataset.src;
	// 			v.dataset.src = '';
	// 			$(v).next().remove();
	// 		}

	// 	} 
	// }); 

});

// 首次加载触发scroll
$(window).trigger("scroll");




// WEBPACK FOOTER //
// ./js/index.js